import { ResourceSelectorState } from './reducer'
import { Resource, resourceNameComparator } from './model'
import fetchSelectors from '../redux/fetch/selectors'
import { ARMApplicationDetail, ARMHybridDetail, Asset, RTFApplication } from '../../remote-api/models'
import selectorSelectors from '../redux/selector/selectors'

export const resourceSelectorSelectors = <S>(getAll: (state: S) => ResourceSelectorState) => {
  const selectors = {
    ...selectorSelectors<Resource, S>(getAll),
    cloudHub: fetchSelectors<ARMApplicationDetail[], S>((state: S) => getAll(state).cloudHub),
    hybrid: fetchSelectors<ARMHybridDetail[], S>((state: S) => getAll(state).hybrid),
    rtf: fetchSelectors<RTFApplication[], S>((state: S) => getAll(state).rtf),
    apis: fetchSelectors<Asset[], S>((state: S) => getAll(state).apis),
    resources: (state: S): Resource[] => {
      const resourceSelectorState = getAll(state)
      if (resourceSelectorState.resources && resourceSelectorState.resources.length > 0) {
        return [...resourceSelectorState.resources].sort(resourceNameComparator)
      } else {
        const chResources = resourceSelectorState.cloudHub.resources || []
        const hybridResources = resourceSelectorState.hybrid.resources || []
        const rtfResources = resourceSelectorState.rtf.resources || []
        const serverResources = resourceSelectorState.servers.resources || []
        const apiResources = resourceSelectorState.apis.resources || []
        const managedAPIResources = resourceSelectorState.managedApis.resources || []
        const unsortedResult = [...chResources, ...hybridResources, ...rtfResources, ...serverResources, ...apiResources, ...managedAPIResources]
        return unsortedResult.sort(resourceNameComparator)
      }
    }
  }

  return {
    ...selectors,
    getAll: (state: S) => {
      return {
        ...getAll(state),
        resources: selectors.resources(state)
      }
    }
  }
}
